import type { EditAsideIdentifier } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentEditNode } from '../../../hooks/UseCurrentEditNode';
import { useEditHref } from '../../../hooks/UseEditHref';

import SimpleInput from './SimpleInput';

const AsideIdentifier: React.FC<{
  config: EditAsideIdentifier;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const currentEditNode = useCurrentEditNode();
  const initialValue = currentEditNode.identifiers?.[0] || '';

  const change = (value: string) => {
    dispatch(
      patchNodeAction(getResourceKey(editHref), set({}, config.property, value), true, null, false),
    );
  };

  return (
    <SimpleInput
      defaultValue={initialValue}
      label={config.label}
      readOnly={readonly}
      onChange={change}
    />
  );
};

AsideIdentifier.displayName = 'AsideIdentifier';

export default AsideIdentifier;

AsideIdentifier.propTypes = {
  config: any,
  readonly: any,
};
